import manifest_45route_45rule from "/tmp/tmpzuleio2h/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@20.17.10_db0@0.2.1_eslint@8.57.1_ioredis@_bdfdc83d94f569976186b1791f740ddb/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}